import { render } from "./BackToLogin.vue?vue&type=template&id=5d9b4069&scoped=true"
import script from "./BackToLogin.vue?vue&type=script&lang=js"
export * from "./BackToLogin.vue?vue&type=script&lang=js"

import "./BackToLogin.vue?vue&type=style&index=0&id=5d9b4069&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d9b4069"]])

export default __exports__